import { render, staticRenderFns } from "./ProxyTrafficDetails.vue?vue&type=template&id=577f5994&scoped=true"
import script from "./ProxyTrafficDetails.vue?vue&type=script&lang=js"
export * from "./ProxyTrafficDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577f5994",
  null
  
)

export default component.exports